import type React from 'react';

import { Banner } from 'src/app/shared/components/banners/layout';
import type { CountryBannerConfig, CountryBannerContext } from 'src/app/shared/hooks/banners/country';

import { useCountryBannerClickTracking, useTrackCountryBannerView } from '../hooks/trackCountryBanner';

export const CountryBannerContainer: React.FC<{
	countryBanner: CountryBannerConfig;
	context: CountryBannerContext;
	petitionId?: string;
}> = ({ petitionId, context, countryBanner }) => {
	useTrackCountryBannerView(countryBanner, context, petitionId);
	const trackClick = useCountryBannerClickTracking(countryBanner, context, petitionId);
	return (
		<Banner
			mobileContent={countryBanner.mobileContent}
			desktopContent={countryBanner.content}
			onLinkClick={trackClick}
		/>
	);
};
